export default {"src":"/_next/static/media/logo-bergesenstiftelsen.60cbb439.svg","height":308,"width":779,"blurWidth":0,"blurHeight":0};